// @core/api/endpoints/billing/get_revenue_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetRevenueReportResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get revenue report
 * Generates a revenue report for the specified period showing income by product, customer segment, and time period breakdowns.
 */
export async function GetRevenueReport(
  params?: {
    currency?: string | number | boolean;
    period_end?: string | number | boolean;
    period_start?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<GetRevenueReportResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/reports/revenue`;
  const requestOptions = options;
  return client.get<GetRevenueReportResponse>(requestPath, { ...requestOptions, params });
}
